var ArrayUtils = /** @class */ (function () {
    function ArrayUtils() {
    }
    ArrayUtils.remove = function (array, elem) {
        var index = array.indexOf(elem);
        return array.splice(index, 1);
    };
    ArrayUtils.tail = function (array, n) {
        if (n === void 0) { n = 0; }
        return array[array.length - (1 + n)];
    };
    ArrayUtils.equals = function (one, other, itemEquals) {
        if (itemEquals === void 0) { itemEquals = function (a, b) { return a === b; }; }
        if (one.length !== other.length) {
            return false;
        }
        for (var i = 0, len = one.length; i < len; i++) {
            if (!itemEquals(one[i], other[i])) {
                return false;
            }
        }
        return true;
    };
    ArrayUtils.findIndex = function (array, predicate) {
        // 1. Let O be ? ToObject(array value).
        if (array == null) {
            throw new TypeError('"array" is null or not defined');
        }
        var o = Object(array);
        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;
        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        // 5. Let k be 0.
        var k = 0;
        // 6. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return k.
            var kValue = o[k];
            if (predicate.call(array, kValue, k, o)) {
                return k;
            }
            // e. Increase k by 1.
            k++;
        }
        // 7. Return -1.
        return -1;
    };
    ArrayUtils.binarySearch = function (array, key, comparator) {
        var low = 0, high = array.length - 1;
        while (low <= high) {
            var mid = ((low + high) / 2) | 0;
            var comp = comparator(array[mid], key);
            if (comp < 0) {
                low = mid + 1;
            }
            else if (comp > 0) {
                high = mid - 1;
            }
            else {
                return mid;
            }
        }
        return -(low + 1);
    };
    /**
     * Takes a sorted array and a function p. The array is sorted in such a way that all elements where p(x) is false
     * are located before all elements where p(x) is true.
     * @returns the least x for which p(x) is true or array.length if no element fullfills the given function.
     */
    ArrayUtils.findFirst = function (array, p) {
        var low = 0, high = array.length;
        if (high === 0) {
            return 0; // no children
        }
        while (low < high) {
            var mid = Math.floor((low + high) / 2);
            if (p(array[mid])) {
                high = mid;
            }
            else {
                low = mid + 1;
            }
        }
        return low;
    };
    /**
     * Returns the top N elements from the array.
     *
     * Faster than sorting the entire array when the array is a lot larger than N.
     *
     * @param array The unsorted array.
     * @param compare A sort function for the elements.
     * @param n The number of elements to return.
     * @return The first n elemnts from array when sorted with compare.
     */
    ArrayUtils.top = function (array, compare, n) {
        if (n === 0) {
            return [];
        }
        var result = array.slice(0, n).sort(compare);
        var _loop_1 = function (i, m) {
            var element = array[i];
            if (compare(element, result[n - 1]) < 0) {
                result.pop();
                var j = ArrayUtils.findFirst(result, function (e) { return compare(element, e) < 0; });
                result.splice(j, 0, element);
            }
        };
        for (var i = n, m = array.length; i < m; i++) {
            _loop_1(i, m);
        }
        return result;
    };
    /**
     * @returns a new array with all undefined or null values removed. The original array is not modified at all.
     */
    ArrayUtils.coalesce = function (array) {
        if (!array) {
            return array;
        }
        return array.filter(function (e) { return !!e; });
    };
    /**
     * Moves the element in the array for the provided positions.
     */
    ArrayUtils.move = function (array, from, to) {
        array.splice(to, 0, array.splice(from, 1)[0]);
    };
    /**
     * @returns {{false}} if the provided object is an array
     * 	and not empty.
     */
    ArrayUtils.isFalsyOrEmpty = function (obj) {
        return !Array.isArray(obj) || obj.length === 0;
    };
    /**
     * Removes duplicates from the given array. The optional keyFn allows to specify
     * how elements are checked for equalness by returning a unique string for each.
     */
    ArrayUtils.distinct = function (array, keyFn) {
        if (!keyFn) {
            return array.filter(function (element, position) {
                return array.indexOf(element) === position;
            });
        }
        var seen = Object.create(null);
        return array.filter(function (elem) {
            var key = keyFn(elem);
            if (seen[key]) {
                return false;
            }
            seen[key] = true;
            return true;
        });
    };
    ArrayUtils.uniqueFilter = function (keyFn) {
        var seen = Object.create(null);
        return function (element) {
            var key = keyFn(element);
            if (seen[key]) {
                return false;
            }
            seen[key] = true;
            return true;
        };
    };
    ArrayUtils.firstIndex = function (array, fn) {
        for (var i = 0; i < array.length; i++) {
            var element = array[i];
            if (fn(element)) {
                return i;
            }
        }
        return -1;
    };
    ArrayUtils.first = function (array, fn, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = null; }
        var index = ArrayUtils.firstIndex(array, fn);
        return index < 0 ? notFoundValue : array[index];
    };
    ArrayUtils.commonPrefixLength = function (one, other, equals) {
        if (equals === void 0) { equals = function (a, b) { return a === b; }; }
        var result = 0;
        for (var i = 0, len = Math.min(one.length, other.length); i < len && equals(one[i], other[i]); i++) {
            result++;
        }
        return result;
    };
    ArrayUtils.flatten = function (arr) {
        return arr.reduce(function (r, v) { return r.concat(v); }, []);
    };
    ArrayUtils.range = function (to, from) {
        if (from === void 0) { from = 0; }
        var result = [];
        for (var i = from; i < to; i++) {
            result.push(i);
        }
        return result;
    };
    ArrayUtils.fill = function (num, valueFn, arr) {
        if (arr === void 0) { arr = []; }
        for (var i = 0; i < num; i++) {
            arr[i] = valueFn();
        }
        return arr;
    };
    ArrayUtils.index = function (array, indexer, merger) {
        if (merger === void 0) { merger = function (t) { return t; }; }
        return array.reduce(function (r, t) {
            var key = indexer(t);
            r[key] = merger(t, r[key]);
            return r;
        }, Object.create(null));
    };
    return ArrayUtils;
}());
export { ArrayUtils };
Array.prototype["remove"] = function (value) {
    var idx = this.indexOf(value);
    if (idx != -1) {
        return this.splice(idx, 1); // The second parameter is the number of elements to remove.
    }
    return false;
};
Array.prototype["insert"] = function (value) {
    var _this = this;
    this.push(value);
    return function () {
        var index = _this.indexOf(value);
        if (index > -1) {
            _this.splice(index, 1);
        }
    };
};
